// This icon file is generated automatically.
var PFilePptOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5.63 6.44a.13.13 0 00-.13.12v4.32c0 .06.06.12.13.12h.5c.07 0 .13-.06.13-.13V9.38h.99c.93 0 1.5-.6 1.5-1.47 0-.85-.57-1.47-1.5-1.47H5.62zM7.97 7.9c0 .68-.42.85-1.11.85h-.61v-1.7h.88c.52 0 .84.31.84.85zm4.37-4.4L9 .15A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .58H8.4V1.15l2.94 2.94zm.03 8.79H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71z", "fill-rule": "nonzero" } }] }, "name": "p-file-ppt", "theme": "outlined" };
export default PFilePptOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFilePptOutlined.js
// module id = 3401
// module chunks = 0